import { Common, ApiBind } from './common.model';

export class DeliverySetTester extends Common {
  @ApiBind({ column: 'tester_id' })
  id: number;
}
